import {z} from 'zod';
import {PartItemDetailDto, UpdatePartsListRequest} from '../../../api/generated/index.defs.ts';
import {
  mapNullToUndefined,
  mapStringNumberToNumber,
} from '../../../utils/zod.ts';

const PartItemSchema = z.object({
  id: mapNullToUndefined(z.number().optional()),
  actionClassId: mapNullToUndefined(
    mapStringNumberToNumber(z.number().optional()),
  ),
  actionCodeId: mapNullToUndefined(
    mapStringNumberToNumber(z.number().optional()),
  ),
  dispositionCodeId: mapNullToUndefined(
    mapStringNumberToNumber(z.number().optional()),
  ),
  action: mapNullToUndefined(z.string().optional()),
  disposition: mapNullToUndefined(z.string().optional()),
  partNumber: mapNullToUndefined(z.string().optional()),
  description: mapNullToUndefined(z.string().optional()),
  class: mapNullToUndefined(z.string().optional()),
  materialSequence: mapNullToUndefined(z.string().optional()),
  qty: mapNullToUndefined(z.number().optional()),
  actionQty: mapNullToUndefined(z.number().optional()),
  canBeChanged: mapNullToUndefined(z.boolean().optional()),
  canBeChangedOverride: mapNullToUndefined(z.boolean().optional()),
  revisionOverride: mapNullToUndefined(z.string().optional()),
  nonMmLotNumber: mapNullToUndefined(z.string().optional()),
  partNameCodeId: mapNullToUndefined(
    mapStringNumberToNumber(z.number().optional()),
  ),
}) satisfies z.Schema<PartItemDetailDto>;

const nonMmPartItemSchema = PartItemSchema.extend({
  nonMmLotNumber: mapNullToUndefined(z.string()),
  partNumber: mapNullToUndefined(z.string()),
  partNameCodeId: mapNullToUndefined(
    mapStringNumberToNumber(z.number().optional()),
  ),
  qty: mapNullToUndefined(z.number()),
});

export const jobPartsListSchema = z.object({
  partItems: z.array(PartItemSchema),
}) satisfies z.Schema<UpdatePartsListRequest>;
export type JobPartsListSchema = z.TypeOf<typeof jobPartsListSchema>;

export const nonMmJobPartsListSchema = z.object({
  partItems: z.array(nonMmPartItemSchema),
}) satisfies z.Schema<UpdatePartsListRequest>;